import React from "react";
import { CurrencyFormatter } from "../../helper/Formatter";
import ReactStars from "react-rating-stars-component";
import ProgressBar from "@ramonak/react-progress-bar";
import "./dataview.css";

export default function DataView(props) {
  let locale = localStorage.getItem("Locale");
  let currency = localStorage.getItem("Currency");

  return (
    <div className=" d-flex">
      <figure
        className="figure white-box mrb30"
        //   style={{
        //     backgroundColor:
        //       foregroundColor !== "" ? "#" + foregroundColor : "",
        //   }}
      >
        <div className="card-content-block">
          <div className="embed-responsive embed-responsive-4by3 position-relative">
            {props?.paid && <p style={{backgroundColor:props.paidVal === "Unpaid" && "#C62E2E"}} className="paid_text">{props.paidVal === "Unpaid" && props.paidVal}</p>}
            <img
              src={
                props.img ? props.img : "/images/no-image.jpg"
                //   service.gallery.length > 0
                //     ? service.gallery[0].attachment
                // :
              }
              className="img-fluid img-tr-round embed-responsive-item"
              alt=""
            />
          </div>
          <div className="px-3 pt-3">
          {props.title && (

            <h6 style={{ height: props.height ? props.height : "auto"}} className="card-title title_of_box mb-1 text-capitalize">
              {props.title ? props.title : ""}
            </h6>
          )}
            {props.subTitleVisible && (
              <p className="card-text subtitle_text mb-1">
                {props.subTitle ? props.subTitle : ""}
              </p>
            )}

            {props.rating && (
              <p className="card-text my-1 ratingVal">
                {props.ratingVal ? props.ratingVal : ""}
                <ReactStars
                  value={props.ratingVal ? props.ratingVal : 0}
                  count={5}
                  // onChange={ratingChanged}
                  edit={false}
                  isHalf={true}
                  size={20}
                  color="rgb(207 207 207)"
                  activeColor="rgba(242, 144, 22, 1)"
                />
              </p>
            )}
            {props.bestSeller && (
              <p
                title={props.bestSellerText ? props.bestSellerText : ""}
                className="card-text mb-1 bestSellerText"
              >
                {props.bestSellerText ? props.bestSellerText : ""}
              </p>
            )}

            {props.startTime && (
              <p className="card-text mb-0 mt-2">
                <i className="fa fa-clock-o" aria-hidden="true" />{" "}
                {props.startTimeData}
              </p>
            )}
            {props.startDate && (
              <p className="card-text m-0">
                <i className="fa fa-calendar" aria-hidden="true" />{" "}
                {props.addStartDate}
              </p>
            )}

            {props.availableRooms && (
              <p className="card-text ">
                {`${props.availableRoom ? props.availableRoom + " units" : ""}`}
              </p>
            )}

            {props.durationTime && (
              <p className="card-text mb-2">
                <i className="fa  fa-clock-o" aria-hidden="true" />
                &nbsp;
                {`${props.duration ? props.duration + " min" : ""}`}
              </p>
            )}

            {props.category && (
              <p
                title={props.categoryName ? props.categoryName : ""}
                className="card-text category_txt"
              >
                <i className="fa fa-book mr-1" aria-hidden="true" />

                {`${props.categoryName ? props.categoryName : ""}`}
              </p>
            )}

            <div className="typeFileName_category_container">
              {props.typeFile && (
                <p
                  title={props.typeFileName ? props.typeFileName : ""}
                  className="card-text category_txt"
                >
                  <i className="fa fa-paperclip" aria-hidden="true" />
                  &nbsp;
                  {`${props.typeFileName ? props.typeFileName : ""}`}
                </p>
              )}

              {props.courseTime && (
                <p className="card-text  category_txt">
                  <i className="fa  fa-clock-o" aria-hidden="true" />
                  &nbsp;
                  {/* {TimeFormatter(h.bookingdate, locale)} */}
                  {`${props.courseDuration ? props.courseDuration : ""}`}
                </p>
              )}
              {props.scheduleDate && (
              <p className="card-text mb-0 mt-2" style={{fontSize:14}}>
                <i className="fa fa-calendar" aria-hidden="true" />{" "}
                {props.scheduleVal}
              </p>
            )}


            </div>

            {props.courseProgress && (
              <div className="card-text bar_complete_container">
                {console.log(
                  "props?.courseProgressVal::: ",
                  props?.courseProgressVal
                )}
                {/* <ProgressBar
                    completed={15}
                    //  barContainerClassName="outside_container_progressbar"
                    completedClassName="barCompleted"
                    className="entire_progressbar_container"
                  /> */}

                <progress
                  className="progress_bar_self"
                  id="file"
                  value={props?.courseProgressVal}
                  max="100"
                  // className="barCompleted"
                />
                <p>{props?.courseProgressVal} % complete </p>
              </div>
            )}
          </div>
        </div>
        <div className="d-flex px-3 ">
          {/* currency implmentation is pending */}
          <div className="flex-grow-1 sl-price" style={{ marginTop : props?.categoryType === "course" && "10px"}}>
            {CurrencyFormatter(
              props.charge ? props.charge : "",
              locale ? locale : "en-IN",
              currency ? currency : "INR"
            )}
          </div>

        </div>
        <div className="d-flex px-3 pb-2 justify-content-end">
        {!props.displayBookingBtn ? (
            <div>
              <button
                // href="#"
                className="cursor-pointer book_now_btn bg-transparent border-0"
                onClick={props.onClick}
                // onClick={() =>
                //   showBookingDetail(
                //     service._id,
                //     service.typeofbooking
                //   )
              >
                {props.bookNowBtnName}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      </figure>
    </div>
  );
}
